import {Injectable, Type} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {
    IntegrationTypeObjectBaseComponent
} from "../../component/object-components/integration-type-object-base-component/integration-type-object-base.component";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";

@Injectable({
    providedIn: 'root'
})
export class IntegrationTypeService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/hc/integrationTypes')
    }

    getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
        if (mode != MvsCrudModeEnum.create) {
            return IntegrationTypeObjectBaseComponent;
        }

        return null;
    }
}